import request from '@/utils/request'

/**
 * 仪表盘
**/
export function getDashboardInfo(params = {}) {
  return request({
    method: 'POST',
    url: 'dashboard.info',
    data: {
      ...params,
    }
  })
}

/**
 * 文章&活动
**/
export function getNewsList(params = {}) {
  return request({
    method: 'POST',
    url: 'news.list',
    data: params
  })
}
export function getNewsDetail(params = {}) {
  return request({
    method: 'POST',
    url: 'news.detail',
    data: params
  })
}
export function updateNews(params = {}) {
  return request({
    method: 'POST',
    url: 'news.update',
    data: params
  })
}

/**
 * 经纪
**/
export function getAgentList(params = {}) {
  return request({
    method: 'POST',
    url: 'agent.list',
    data: params
  })
}
export function getAgentDetail(params = {}) {
  return request({
    method: 'POST',
    url: 'agent.detail',
    data: params
  })
}
export function updateAgent(params = {}) {
  return request({
    method: 'POST',
    url: 'agent.update',
    data: params
  })
}
export function updateAgentInfo(params = {}) {
  return request({
    method: 'POST',
    url: 'agent.updateto',
    data: params
  })
}

/**
 * 客户
**/
export function getCustomerList(params = {}) {
  return request({
    method: 'POST',
    url: 'customer.list',
    data: params
  })
}
export function getCustomerDetail(params = {}) {
  return request({
    method: 'POST',
    url: 'customer.detail',
    data: params
  })
}
export function updateCustomer(params = {}) {
  return request({
    method: 'POST',
    url: 'customer.update',
    data: params
  })
}
export function getCustomerUnallocated(params = {}) {
  return request({
    method: 'POST',
    url: 'customer.unallocated',
    data: params
  })
}

/**
 * 用户
**/
export function getUserInfo(){
  return request({
    method: 'POST',
    url: 'user.info',
  })
}
export function editUserInfo(params) {
  return request({
    method: 'POST',
    url: 'user.edit',
    data: params
  })
}

/**
 * 登录
**/
export function register(params = {}) {
  return request({
    method: 'POST',
    url: 'auth.signup',
    data: params
  })
}
export function login(params = {}) {
  return request({
    method: 'POST',
    url: 'auth.signin',
    data: params,
  })
}
export function forgetPassword(params = {}) {
  return request({
    method: 'POST',
    url: 'auth.forgotpass',
    data: params,
  })
}
export function resetPassword(params = {}) {
  return request({
    method: 'POST',
    url: 'auth.resetpass',
    data: params,
  })
}

/**
 * 支付接口
**/
export function getPayment(params = {}) {
  return request({
    method: 'POST',
    url: 'payment.createorder',
    data: params
  })
}
export function getPaymentStatus(params = {}) {
  return request({
    method: 'POST',
    url: 'payment.checkstatus',
    data: params
  })
}
